module.exports = __webpack_public_path__ + "static/media/th.bcc03a3c.svg";